import { Flex, FlexProps } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MeetingIcon } from 'src/icons'
import useMeetingOrigin from '../hooks/useMeetingOrigin'

// #123: says which meeting a creation form comes from. Renders nothing when
// the form was not opened from a running meeting.
export default function MeetingOriginBanner(props: FlexProps) {
  const { t } = useTranslation()
  const origin = useMeetingOrigin()
  if (!origin) return null

  return (
    <Flex
      align="center"
      gap={2}
      px={3}
      py={2}
      borderRadius="md"
      fontSize="sm"
      fontWeight="bold"
      bg="purple.50"
      color="purple.700"
      _dark={{ bg: 'purple.900', color: 'purple.100' }}
      {...props}
    >
      <MeetingIcon size={16} />
      {t('MeetingOriginBanner.label', { circle: origin.circleName })}
    </Flex>
  )
}
